/**
 * File obfuscate.js.
 *
 * The <a> element does not display the email address in the HTML. It only contains the encoded email as a data attribute, keeping the actual email hidden from simple scrapers. When the page loads, JavaScript looks for elements with the class .obfuscated-eaddy, decodes the email address using atob(), and then sets both the href (as a proper mailto: link) and the element's text content to the decoded email address.
 */
(function() {
	function processEmailLinks(container = document) {
		const mailLinks = container.querySelectorAll('.obfuscated-eaddy');
		function htmlEntityEncode(str) {
			return str.split('').map(char => `&#${char.charCodeAt(0)};`).join('');
		}
		mailLinks.forEach(link => {
			// Retrieve the encoded email from the data attribute
			if (link.dataset.processed) return; // Prevent re-processing already handled links
			const encodedEmail = link.getAttribute('data-eaddy');
			if (encodedEmail) {
				// Decode the email address
				const email = atob(encodedEmail);
				// Set the innerHTML to the HTML entity encoded version of the email
				if (link.classList.contains('mail-label')) {
					//create a click  event listener to convert the email to a mailto link. then execute the click event
					link.addEventListener('click', function(event) {
						//prevent default action
						event.preventDefault();
						//execute the click event
						window.location.href = 'mailto:' + email;
					});
				} else {
					// Set the href to a proper mailto link
					link.setAttribute('href', 'mailto:' + email);
					link.innerHTML = htmlEntityEncode(email);
				}
				link.dataset.processed = "true"; // Mark as processed
			}
		});
	}
	// Process existing elements on page load
	processEmailLinks();
	// Watch for dynamically added elements using MutationObserver
	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === 1) { // Ensure it's an element node
					if (node.matches('.obfuscated-eaddy')) {
						processEmailLinks(node);
					} else {
						processEmailLinks(node);
					}
				}
			});
		});
	});
	observer.observe(document.body, { childList: true, subtree: true });
})();
